



























































































































































































































import { AttendInfo } from '@/models/CeremonyFormModel';
import { EventInfoModel } from '@/models/EventFormModel';
import Vue from 'vue';

export default Vue.extend({
  props: {
    checkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      attendInfo: [
        new AttendInfo('', '', '', '', '', '', '', '', ''),
      ],
      genderSelection: [
        'male',
        'female',
      ],
      moments: [
        'beforeBreakfast',
        'beforeLunch',
        'beforeDinner',
        'afterDinner',
      ],
    };
  },
  computed: {
    eventInfo(): EventInfoModel {
      return this.$store.state.eventInfo;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.attendInfo = this.$store.state.form.ceremonyForm.attendInfoList;
    },
    clearData() {
      this.$notify({
        type: 'info',
        title: '已清空資料',
      });
      this.attendInfo = [
        new AttendInfo('', '', '', '', '', '', '', '', ''),
      ];
      this.$store.commit('updateAttendInfo', this.attendInfo);
    },
    deletePerson(key: number) {
      this.attendInfo.splice(key, 1);
    },
    addPerson() {
      this.attendInfo.push(new AttendInfo('', '', '', '', '', '', '', '', ''));
    },
    goStep(move: string) {
      if (move === 'last') {
        this.$router.push('prayFor');
      }
      if (move === 'next') {
        this.$router.push('checkForm');
      }
    },
    eventDates(str: string) {
      const aaa = str.split('T', 1);
      return aaa[0];
    },
  },
});
